export default "__VITE_PUBLIC_ASSET__9317d928__"